import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import VoucherAd from '../components/voucher-ad'
import FaqList from '../components/faq-list'
import config from '../../data/siteConfig'

const FaqsPage = ({data}) => (
  <span>
    <Helmet
      title={`${config.siteName} | FAQs | ${config.siteTitleAlt}`}
      meta={[
        {
          name: 'description',
          content: 'For all your questions about booking your 4x4 experience day visit this page. We’re based just north of Cardiff in South Wales and have a specially designed off roading course to suite all driving experiences.'
        }
      ]}
    />
    <div className="faqs banner">
      <div className="banner-info top-off-center text-center">
        <h2 className="uppercase">We've hopefully put together answers to most of the questions you might have</h2>
      </div>
    </div>
    <main>
      <section className="row">
        <div className="small-12 medium-10 columns">
          <div className="content-header">
            <h1 className="uppercase">FAQs</h1>
          </div>
        </div>
      </section>
      <section className="row">
        <div className="large-9 columns">
          <div className="content-body">
            <FaqList faqs={data.dataJson.items}/>
          </div>
        </div>
        <aside className="large-3 columns">
          <div className="content-body">
            <VoucherAd />
          </div>
        </aside>
      </section>
    </main>
  </span>
)

export const query = graphql`
  query FaqsQuery {
    dataJson {
      items {
        question
        answer
      }
    }
  }
`

export default FaqsPage



// WEBPACK FOOTER //
// ./src/pages/faqs.js